export const siteData = {
  "name": "rovinz",
  "address": "12 rue de de la boetie",
  "postCode": "75008",
  "city": "PARIS",
  "phone": "0430298817",
  "url": "https://rovinz.art",
  "urlSub": "rovinz.art",
  "host": "45.32.145.53",
  "price": "price_1RN9DHFF1JoZBsQvpsoWTu6Y",
  "pk": "pk_live_51RUGFuI8X6uoubNKtYfB5gpirkG3td404g3C3HxwRh2kYhwd3swM2CPyJ4Yle0c9oXF1s3PtHtDFnlDloXgJY10Y005Kq41jXL",
  "sk": "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"
};